import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import "./ProductCard.css";
import { addToCart } from "../../utils/addToCart";

const ProductCard = ({ product, isInWishlist = false, onWishlistToggle }) => {
  const [hovered, setHovered] = useState(false);
  const [images, changeImage] = useState({
    main: "https://upload.wikimedia.org/wikipedia/commons/thumb/6/65/No-Image-Placeholder.svg/1665px-No-Image-Placeholder.svg.png",
    hovered:
      "https://upload.wikimedia.org/wikipedia/commons/thumb/6/65/No-Image-Placeholder.svg/1665px-No-Image-Placeholder.svg.png",
  });

  const setImage = () => {
    if (product.frontImage) {
      console.log(
        `product.image_url : ${product.frontImage} && product.image_url.startsWith("https") : ${product.frontImage.startsWith("https")}`,
      );
      if (product.frontImage.startsWith("https")) {
        changeImage({
          main: product.frontImage,
          hovered: product.backImage || product.image_url,
        });
      } else {
        changeImage({
          main: "https://upload.wikimedia.org/wikipedia/commons/thumb/6/65/No-Image-Placeholder.svg/1665px-No-Image-Placeholder.svg.png",
          hovered:
            "https://upload.wikimedia.org/wikipedia/commons/thumb/6/65/No-Image-Placeholder.svg/1665px-No-Image-Placeholder.svg.png",
        });
      }
    } else {
      changeImage({
        main: "https://upload.wikimedia.org/wikipedia/commons/thumb/6/65/No-Image-Placeholder.svg/1665px-No-Image-Placeholder.svg.png",
        hovered:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/6/65/No-Image-Placeholder.svg/1665px-No-Image-Placeholder.svg.png",
      });
    }
  };

  useEffect(() => {
    setImage();
  }, [product]);

  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      whileInView={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5 }}
      className="collection-product-card"
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
    >
      {/* Product Labels */}
      {product.discount && (
        <span className="product-label discount">{product.discount}</span>
      )}
      {product.soldOut && (
        <span className="product-label sold-out">SOLD OUT</span>
      )}
      {!product.discount && !product.soldOut && (
        <span className="product-label new">NEW</span>
      )}

      {/* Heart Icon */}
      <button
        className={`heart-icon ${isInWishlist ? "filled" : ""}`}
        onClick={(e) => {
          e.preventDefault();
          e.stopPropagation();
          if (onWishlistToggle) {
            onWishlistToggle();
          }
        }}
      >
        {isInWishlist ? "♥" : "♡"}
      </button>

      {/* Product Image */}
      <Link to={`/products/${product.slug}`}>
        <img
          src={hovered ? images.hovered : images.main}
          alt={product.title}
          className="product-image"
        />
      </Link>

      {/* Quick Add Overlay */}
      {hovered && !product.soldOut && (
        <div className="quick-add-overlay">
          <p className="quick-add-title">QUICK ADD</p>
          <div className="size-options">
            {Array.isArray(product.variants) && product.variants.length > 0 ? (
              product.variants.map((variant, index) => (
                <button key={index} className="size-btn" onClick={() => addToCart(product.id || product.product_id, 1, variant.variant_id)}>
                  {variant.size}
                </button>
              ))
            ) : (
              <button className="size-btn">+ ADD</button>
            )}
          </div>
        </div>
      )}

      {/* Product Info */}
      <div className="product-info">
        <Link to={`/products/${product.slug}`} className="product-title">
          {product.title}
        </Link>
        <p className="product-color">{product.color}</p>
        <div className="product-price">
          <span className="current-price">
            £{(product.price || 0).toFixed(2)}
          </span>
          {product.originalPrice && product.originalPrice !== product.price && (
            <span className="original-price">
              £{(product.originalPrice || 0).toFixed(2)}
            </span>
          )}
        </div>
      </div>
    </motion.div>
  );
};

export default ProductCard;
